import type { LayoutConfig } from '@/utils/dealCalculations'
import type { PlanServiceItem } from '@/utils/dealCalculations'
import { computeCategoryBlocksPercent } from '@/utils/pptxSlideCategoryLayout'
import { buildCategoryLayoutBlocks } from './layoutSlideBlocks'

export type SlideCategoryBlock = {
  categoria: string
  items: PlanServiceItem[]
  x: number
  y: number
  widthPercent: number
}

export function computeCategoryBlockNumbers(
  layout: LayoutConfig,
  serviceGroups: Map<string, PlanServiceItem[]>,
): Map<string, number> {
  const names = Array.from(serviceGroups.keys())
  return new Map(buildCategoryLayoutBlocks(layout, names).map((b) => [b.category, b.number]))
}

export function computeSlideCategoryBlocks(
  layout: LayoutConfig,
  serviceGroups: Map<string, PlanServiceItem[]>,
  leftBlockWidth: number,
): SlideCategoryBlock[] {
  return computeCategoryBlocksPercent(layout, serviceGroups, leftBlockWidth)
}
